var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.756,
    height: 22.345,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42",
    d: "M23.007 11.172A10.423 10.423 0 1 1 12.585.747a10.422 10.422 0 0 1 10.422 10.425Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 363",
    fill: "#a6674a",
    d: "M.001 7.977h4.957v7.04H.001z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "M13.382 12.136H2.167a1.315 1.315 0 0 1-.287-.018.644.644 0 0 1 .118-1.269h11.426c-.062-.067-.1-.11-.14-.15l-3.221-3.221a.693.693 0 0 1-.241-.5.647.647 0 0 1 1.035-.522 1.122 1.122 0 0 1 .134.123l4.391 4.392a.661.661 0 0 1 0 1.056q-2.212 2.212-4.422 4.425a.662.662 0 0 1-.686.212.645.645 0 0 1-.327-1.026 1.726 1.726 0 0 1 .125-.132q1.6-1.605 3.21-3.21a1.268 1.268 0 0 1 .132-.1Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.61ab3b808521e44d7d7935c4a588534b.svg";
export { ForwardRef as ReactComponent };